import styles from './styles.module.scss';
import { useState, useEffect } from 'react';
import axios, { AxiosRequestConfig } from 'axios';
import { Board } from '../../../../../components/Board';
import { useNavigate } from 'react-router-dom';
import { verifyRoutePermissions } from '../../../../../globalFunctions';
import { NavButton } from '../../../../../components/NavButton';
import Banco from './Banco';
import { User } from '../../../../../types';

const API_BASE =
  process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_title || '';

export const BancoQuestoes: React.FC = () => {
  const [nome, setNome] = useState('');
  const [editNome, setEditNome] = useState('');
  const [editingId, setEditingId] = useState<number | null>(null);
  const [banco, setBancos] = useState<any>([]);


  const [userAuth, setUserAuth] = useState<User>({} as User);

  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${userAuth.id}`,
      Accept: 'application/json',
    },
  };


console.log(banco)
  const navigate = useNavigate();

  useEffect(() => {
    verifyRoutePermissions(
      ['auth', 'email.verified', 'not.pending.update', 'logicmanager.classes'],
      navigate
    );
    fetchPublications();
  }, [navigate]);

  const fetchPublications = async () => {
    try {
      const { data } = await axios.get(`${API_BASE}/api/bancos`, requestConfig);
      setBancos(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Erro ao buscar publicações:', error);
    }
  };

  const resetForm = () => {
    setNome('')
    cancelEdit();
  };

  const adicionarPublicacao = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('nome', nome);;

      await axios.post(`${API_BASE}/api/bancos`, formData, requestConfig);

      resetForm();
      fetchPublications();
    } catch (error) {
      console.error('Erro ao adicionar publicação:', error);
    }
  };

  const editarPublicacao = (pub: any) => {
    setEditingId(pub.id ?? null);
    setEditNome(pub.nome)
  };

  const submitEdit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (editingId === null) return;
    try {
      const formData = {
        nome: editNome
      };

      await axios.put(`${API_BASE}/api/bancos/${editingId}`, formData, requestConfig);

      resetForm();
      fetchPublications();
    } catch (error) {
      console.error('Erro ao editar publicação:', error);
    }
  };

  const cancelEdit = () => {
    setEditNome('')
  };

  const deletarPublicacao = async (id: number) => {
    try {
      await axios.delete(`${API_BASE}/api/bancos/${id}`, requestConfig);
      setBancos((prev) => prev.filter((p) => p.id !== id));
    } catch (error) {
      console.error('Erro ao deletar publicação:', error);
    }
  };

  const goBackwards = () => navigate('/manager');

  return (
    <div className={styles.wrapper}>
      <Board wrapperClass={styles.board}>
        <div className={styles.container}>
          <h1 className={styles.titulo}>Gerenciamento de Perguntas</h1>

          <form
            onSubmit={editingId !== null ? submitEdit : adicionarPublicacao}
            className={styles.form}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                height: '30vh',
                padding: '1rem',
              }}
            >
          
                
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                    >
                      <input
                        type="text"
                        placeholder={"Insira o nome do banco de questões"}
                        value={ editingId? editNome : nome}
                        onChange={(e) => editingId? setEditNome(e.target.value) : setNome(e.target.value)}
                        required
                        style={{
                          width: '25vw',
                          padding: '0.5rem',
                          flexGrow: 1,
                          minWidth: '150px',
                        }}
                      />
                    </div>
              </div>
            <div className={styles.actions}>
              <button
                type="submit"
                className={editingId !== null ? styles.btnEdit : styles.btnAdd}
              >
                {editingId !== null ? 'Salvar Edição' : 'Adicionar Banco de questões'}
              </button>
              {editingId !== null && (
                <button
                  type="button"
                  onClick={cancelEdit}
                  className={styles.btnCancel}
                >
                  Cancelar
                </button>
              )}
            </div>
          </form>
          <div className={styles.lista}>
            {banco.map((pub) => (
              <div key={pub.id} className={styles.item}>
                <Banco
                  p={pub}
                  deletarMembro={deletarPublicacao}
                  editar={editarPublicacao}
                />
              </div>
            ))}
          </div>
        </div>
      </Board>

      <NavButton
        direction="left"
        style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
        onClick={goBackwards}
      />
    </div>
  );
};
